package com.downdogapp.client.controllers

import com.downdogapp.client.*
import com.downdogapp.client.api.LinkType
import com.downdogapp.client.api.RecordLinkClickedRequest
import com.downdogapp.client.api.Song
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.Network
import com.downdogapp.client.views.SongView

class SongViewController(val song: Song) : ViewController() {

  override val view = SongView(this)

  private val player: MediaPlayer =
    audioPlayer(loop = true).apply {
      song.previewUrl?.let {
        setFile(CommonUri(it))
      }
    }

  val isPlaying get() = player.isPlaying

  fun togglePlaying() {
    if (Network.isOffline()) {
      App.alert(message = Strings.NEED_INTERNET_FOR_SONG_PREVIEW_MESSAGE)
    } else {
      player.togglePlaying()
    }
  }

  fun linkClicked(url: String, linkType: LinkType) {
    logClick("link_clicked", mapOf("link_type" to linkType.name, "song_id" to song.id))
    player.pause()
    Network.post(RecordLinkClickedRequest(song.id, linkType))
    App.openUrl(url)
  }

  override fun onPopped() {
    player.pause()
    player.releasePlayer()
  }
}
